import { settings } from '../settings';

/**
 * Whether title plates hold still: the player's system asks for reduced motion, or the game's
 * flash setting (จอวาบ) is off. Plates step their motion at 12 frames a second, like pixel art.
 */
const reduced = typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null;

export const platesStill = (): boolean => !!reduced?.matches || !settings.flash;

/** The time to draw plates at: stepped, or 0 when they hold still. */
export const plateClock = (t: number): number => (platesStill() ? 0 : Math.floor(t * 12) / 12);
